export default __webpack_public_path__ + "css/customerDetails.bundle.css";